/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';
import { BuilderSharedGanttChartModule } from '@gh/builder-shared-gantt-chart';

import { BuilderSetupSchedulingRoutingModule } from './builder-setup-scheduling-routing.module';
import { ScheduleTemplateGanttDetailsComponent } from './components/schedule-template-gantt-details/schedule-template-gantt-details.component';
import { SchedulingCalendarDetailsComponent } from './components/scheduling-calendar-details-tab/scheduling-calendar-details-tab.component';
import { SchedulingCpDetailsCcListComponent } from './components/scheduling-cp-details/scheduling-cp-details-cc-list/scheduling-cp-details-cc-list.component';
import { SchedulingCpDetailsStageListComponent } from './components/scheduling-cp-details/scheduling-cp-details-stage-list/scheduling-cp-details-stage-list.component';
import { SchedulingCpDetailsComponent } from './components/scheduling-cp-details/scheduling-cp-details.component';
import { SchedulingScheduleTemplateDetailsDialogComponent } from './components/scheduling-schedule-template-details-dialog/scheduling-schedule-template-details-dialog.component';
import { SchedulingScheduleTemplateDetailsTopFormComponent } from './components/scheduling-schedule-template-details/scheduling-schedule-template-details-top-form/scheduling-schedule-template-details-top-form.component';
import { SchedulingScheduleTemplateDetailsComponent } from './components/scheduling-schedule-template-details/scheduling-schedule-template-details.component';
import { SchedulingScheduleTemplateTaskDetailsTopFormComponent } from './components/scheduling-schedule-template-task-details/scheduling-schedule-template-task-details-top-form/scheduling-schedule-template-task-details-top-form.component';
import { SchedulingScheduleTemplateTaskDetailsComponent } from './components/scheduling-schedule-template-task-details/scheduling-schedule-template-task-details.component';
import { SchedulingScheduleTemplateTaskDetailsTodoDialogComponent } from './components/scheduling-schedule-template-task-details/scheduling-schedule-template-task-todo-dialog/scheduling-schedule-template-task-todo-dialog.component';
import { SchedulingScheduleTemplateListSubtabComponent } from './components/scheduling-schedule-templates-tab/scheduling-schedule-template-list-subtab/scheduling-schedule-template-list-subtab.component';
import { SchedulingScheduleTemplatesTabComponent } from './components/scheduling-schedule-templates-tab/scheduling-schedule-templates-tab.component';
import { SchedulingSupplierListTabComponent } from './components/scheduling-supplier-list-tab/scheduling-supplier-list-tab.component';
import { SchedulingTabContainerComponent } from './components/scheduling-tab-container/scheduling-tab-container.component';
import { ScheduleTemplateGanttDetailsBusinessService } from './resources/schedule-template-gantt-details-business.service';
import { SchedulingCalendarDetailsBusinessService } from './resources/scheduling-calendar-details-business.service';
import { SchedulingCpDetailsBusinessService } from './resources/scheduling-cp-details-business.service';
import { SchedulingScheduleTemplateBusinessService } from './resources/scheduling-schedule-template-business.service';
import { SchedulingScheduleTemplateTaskBusinessService } from './resources/scheduling-schedule-template-task-business.service';
import { SchedulingSupplierListBusinessService } from './resources/scheduling-supplier-list.business.service';

@NgModule({
  imports: [
    CoreUiExtSplitPaneModule,
    BuilderSharedGanttChartModule,
    BuilderSharedModule.forChild(),
    BuilderSetupSchedulingRoutingModule,
  ],
  providers: [
    SchedulingCpDetailsBusinessService,
    SchedulingSupplierListBusinessService,
    SchedulingScheduleTemplateBusinessService,
    SchedulingCalendarDetailsBusinessService,
    SchedulingScheduleTemplateTaskBusinessService,
    ScheduleTemplateGanttDetailsBusinessService,
  ],
  declarations: [
    SchedulingCpDetailsComponent,
    SchedulingCpDetailsStageListComponent,
    SchedulingCpDetailsCcListComponent,
    SchedulingTabContainerComponent,
    SchedulingScheduleTemplatesTabComponent,
    SchedulingScheduleTemplateListSubtabComponent,
    SchedulingSupplierListTabComponent,
    SchedulingScheduleTemplateDetailsDialogComponent,
    SchedulingScheduleTemplateTaskDetailsTodoDialogComponent,
    SchedulingScheduleTemplateDetailsComponent,
    SchedulingScheduleTemplateDetailsTopFormComponent,
    SchedulingCalendarDetailsComponent,
    SchedulingScheduleTemplateTaskDetailsComponent,
    SchedulingScheduleTemplateTaskDetailsTopFormComponent,
    ScheduleTemplateGanttDetailsComponent,
  ],
  entryComponents: [
    SchedulingScheduleTemplateDetailsDialogComponent,
    SchedulingScheduleTemplateTaskDetailsTodoDialogComponent,
    SchedulingScheduleTemplateDetailsTopFormComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})
export class BuilderSetupSchedulingModule {
}
